module.exports = __webpack_public_path__ + "static/sprite-gameengineering-7a8add3a4b625f16e5a99a7d57c58f54.png";